import script from "./BulmaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BulmaInput.vue?vue&type=script&setup=true&lang=js"

import "./BulmaInput.vue?vue&type=style&index=0&id=383ee265&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383ee265"]])

export default __exports__